import { Text } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";

import { VisitOccurrenceStatuses } from "../constants";
import { type PatientData, type VisitOccurrenceData } from "../types";
import { VisitOccurrencesList } from "./List";

interface VisitOccurrencesContentProps {
  patient: PatientData | undefined;
  visitOccurrences: VisitOccurrenceData[];
}

export function VisitOccurrencesContent(props: VisitOccurrencesContentProps) {
  const { patient, visitOccurrences } = props;

  const approvedOccurrences = visitOccurrences.filter(
    (occurrence) => occurrence.attributes.status === VisitOccurrenceStatuses.APPROVED
  );

  return (
    <DialogContent>
      <Stack alignItems="center" spacing={5} sx={{ height: "100%" }}>
        <Text variant="h3" textAlign="center">
          {patient?.attributes.externalPatientIdentifier}
        </Text>
        <Text variant="body2" textAlign="center">
          {approvedOccurrences.length} of {visitOccurrences.length} total visits approved
        </Text>

        <VisitOccurrencesList visitOccurrences={visitOccurrences} />
      </Stack>
    </DialogContent>
  );
}
